module.exports = __webpack_public_path__ + "static/media/wp-add-admin-user.59133cea.png";